<template>
  <div class="viaggistandardpage-container">
    <v-simple-table dense class="standard-table">
      <template v-slot:default>
        <thead>
          <tr class="text-center text-body-1" colspan="19">
            <strong></strong>
          </tr>
          <tr>
            <th class="text-center text-body-1" colspan="19">
              <strong>CRCUITI DI RACCOLTA E/O DI DISTRIBUZIONE O SERVIZIO DI NAVETTA</strong>
            </th>
          </tr>
          <tr>
            <th v-for="(letter, index) in letters" :key="`th-${index}`" class="text-center">
              {{ letter }}
            </th>
            <th></th>
          </tr>

          <tr v-show="showHeader">
            <th class="text-center" v-for="({ text, colspan }, index) in headers" :key="index" :colspan="colspan">
              {{ text }}
            </th>
          </tr>

          <tr v-show="showSubheader">
            <th
              class="text-center text-caption text--secondary py-2"
              v-for="({ text, width }, index) in subheaders"
              :key="index"
              :width="width"
              style="line-height: 10px"
            >
              <small>{{ text }}</small>
            </th>
          </tr>
        </thead>
        <tbody>
          <template>
            <tr v-for="(row, index) in rows" :key="`row-${index}`">
              <td
                v-for="(col, index) in 'AXYZKBCDEFGHILMNOPQRST'.toLowerCase().split('')"
                :key="`table-col-${index}`"
                :class="`table-col table-col__${col}`"
                v-text="row[col]"
              ></td>
              <td class="table-col table-col__via">
                {{ row.via }}
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  props: {
    journeys: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      letters: 'A    BCDEFGHILMNOPQRST'.split(''),
      headers: [
        { text: 'Data', colspan: 1 },
        { text: 'Portata utile', colspan: 1 },
        { text: 'N. assi', colspan: 1 },
        { text: 'Portata utile', colspan: 1 },
        { text: 'N. assi', colspan: 1 },
        { text: 'Origine', colspan: 1 },
        { text: 'Destinazione', colspan: 1 },
        { text: 'Merce raccolta', colspan: 4 },
        { text: 'Merce consegnata', colspan: 4 },
        { text: 'Distanza percorsa', colspan: 2 },
        { text: 'n. di fermate solo per i circuiti', colspan: 1 },
        {
          text: 'n. di fermate nella provincia di origine del viaggio',
          colspan: 1,
        },
        { text: 'n. di viaggi', colspan: 1 },
        { text: 'Tipo di circuito', colspan: 1 },
        { text: 'Tipo viaggio*', colspan: 1 },
        { text: 'VIA', colspan: 1 },
      ],
      subheaders: [
        { text: 'gg/mm', width: '1px' },
        { text: 'Rimorchio se agganciato', width: '10px' },
        { text: 'Rimorchio se agganciato', width: '10px' },
        { text: 'Semirimorchio se agganciato', width: '10px' },
        { text: 'Semirimorchio se agganciato', width: '10px' },
        { text: 'comune e provincia', width: '200px' },
        { text: 'comune e provincia', width: '200px' },
        {
          text: 'tipo merce codice lista a; (se viaggi a vuoto codice=0)',
          width: '1px',
        },
        { text: 'merce pericolosa codice lista b', width: '1px' },
        { text: 'q.li totali', width: '1px' },
        { text: 'aspetto del carico codice lista c', width: '1px' },
        {
          text: 'tipo merce codice lista a; (se viaggi a vuoto codice=0)',
          width: '1px',
        },
        { text: 'merce pericolosa codice lista b', width: '1px' },
        { text: 'q.li totali', width: '1px' },
        { text: 'aspetto del carico codice lista c', width: '1px' },
        { text: 'km con carico', width: '1px' },
        { text: 'km a vuoto', width: '1px' },
        { text: 'per ciascun viaggio', width: '1px' },
        { text: 'solo per i circuiti', width: '1px' },
        { text: 'effettuati nel corso della giornata', width: '1px' },
        { text: 'raccolta=1 distribuzione=2 navetta=3', width: '10px' },
        { text: 'circuito=3 navetta=5 vuoto=6', width: '10px' },
        { text: '', width: '1px' },
      ],
      showHeader: true,
      showSubheader: true,
    }
  },
  computed: {},
  methods: {
    getTypeCode(type, circuitType) {
      try {
        if (type === 3) return 3
        if (type === 2) {
          if (circuitType === 1) {
            return 1
          } else if (circuitType === 2) {
            return 2
          } else if (circuitType === 3) {
            return 4
          }
          return 0
        }
      } catch (e) {
        console.error('ERR: ', e)
        return 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.table-col {
  color: #333 !important;
  font-family: 'Roboto Mono', monospace;
  font-weight: 400;

  text-align: center !important;

  &__b,
  &__c {
    text-align: left !important;
  }

  &__a,
  &__via {
    padding: 0 8px !important;
  }
}

.standard-table {
  border: thin solid rgba(0, 0, 0, 0.12);
  td {
    border-left: thin solid rgba(0, 0, 0, 0.12);
    font-size: 12px !important;
    color: #333 !important;
  }
  td:first-child {
    border-left: none;
  }
  th {
    border-left: thin solid rgba(0, 0, 0, 0.12);
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    padding: 0 2px !important;
  }
  th:first-child {
    border-left: none;
  }
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>
